export const CHECKBOX_FULL_ICON: string = '/assets/img/project-v2/checkbox-full.svg';
export const CHECKBOX_EMPTY_ICON: string = '/assets/img/project-v2/checkbox-empty.svg';
export const CHECKBOX_PARTIAL_ICON: string = '/assets/img/project-v2/checkbox-partial.svg';

